export interface DownloadLabels {
  trigger: string
  /** Tooltip / aria-label shown on the trigger while a download is in flight. */
  loading: string
  /**
   * Tooltip / aria-label shown on the trigger after a download failed. Cleared
   * the next time the menu opens.
   */
  error: string
}

export const DEFAULT_DOWNLOAD_LABELS: DownloadLabels = {
  trigger: 'Download',
  loading: 'Downloading…',
  error: 'Download failed',
}
